<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">

            <div class="col-lg-12 col-xl-12">
                <div class="card-box">
                    <b-tabs content-class="mt-1" pills justified class="navtab-bg">
                        <b-tab title="Info" active>
                            <CompanyInfo
                                    :id="id"
                                    :company="company"
                                    :companyData="companyData" />
                        </b-tab>
                        <b-tab title="Document">
                            <CompanyDocument
                                    :id="id"
                                    :company="company"
                                    :companyData="companyData" />
                        </b-tab>
                        <b-tab title="Settings">
                            <CompanySettings
                                    :id="id"
                                    :company="company"
                                    :companyData="companyData" />
                        </b-tab>
                    </b-tabs>
                </div>
                <!-- end card-box-->
            </div>
            <!-- end col -->
        </div>
        <!-- end row-->
    </Layout>
</template>

<script>

  import appConfig from '@src/app.config'
  import Layout from '@layouts/main'
  import PageHeader from '@components/page-header'

  import CompanyInfo from '@components/company/company-info'
  import CompanyDocument from '@components/company/company-document'
  import CompanySettings from '@components/company/company-settings'

  import {
    required,
    email,
    minLength,
    maxLength,

  } from 'vuelidate/lib/validators'

  import { companiesMethods } from '@state/helpers'
  import { states, partners } from '@views/data'

  /**
   * Profile component
   */
  export default {
    page: {
      title: 'Company Details',
      meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader, CompanyInfo, CompanyDocument, CompanySettings },
    data() {
      return {
        title: 'Company Details',
        items: [
          {
            text: '99Gift',
            href: '/',
          },
          {
            text: 'Companies',
            href: '/',
          },
          {
            text: 'Company-Details',
            active: true,
          },
        ],
        id: null,
        company : {
          partnerTypes: partners,
          states: states,
          companyId: '',
          name: '',
          email: '',
          telephone: '',
          contactPerson: '',
          contactNumber: '',
          partnerType: '',
          stateValue: '',
          address:''
        },
        submitted: false,
      }
    },
    validations: {
      company : {
        companyId: { required, minLength: minLength(10), maxLength: maxLength(10) },
        name: { required },
        email: { required, email },
        telephone: { required, minLength: minLength(7), maxLength: maxLength(15) },
        contactPerson: { required },
        contactNumber: { required, minLength: minLength(7), maxLength: maxLength(15) },
        partnerType: { required },
        stateValue: { required },
        address: { required }
      },
    },
    async mounted() {

      this.id = parseInt(this.$route.params.id)

      this.companyData()
    },
    methods: {

      ...companiesMethods,

      companyData: async function() {

        try{
          const { success, data: { result } } = await this.companyDetails(this.id)

          if(!success) throw  Error('Error while getting profile')

          const {
            company_id: companyId,
            email,
            telephone,
            name,
            token_id: tokenId,
            logo,
            contact_person: contactPerson,
            contact_no: contactNumber,
            address,
            role,
            gst_no: gstNo,
            gst_file: gstFile,
            roc_no: rocNo,
            roc_file: rocFile,
            pan_no: panNo,
            pan_file: panFile,
            state
          } = result

          const partnerType = partners.find((each) => {
            if(each.id === role){
              return each
            }
          });

          this.company = {
            companyId,
            email,
            telephone,
            name,
            logo,
            tokenId,
            contactPerson,
            contactNumber,
            address,
            partnerTypes: partners,
            states: states,
            partnerType,
            stateValue: state,
            gstNo,
            gstFile,
            rocNo,
            rocFile,
            panNo,
            panFile
          };
        }
        catch (e){
          this.appToast('Exception', e.message || 'Error while operating!', 'danger')
          this.$router.back()
        }
      },

      submitUpdate: async function (event) {

        try{
          this.submitted = true

          const telephoneRegex = /^\+[1-9]{1}[0-9]{3,14}$/;

          this.$v.$touch()
          if (!this.$v.$invalid) {

            const {
              companyId,
              email,
              telephone,
              name,
              contactPerson,
              contactNumber,
              address
            } = this.company;

            if(!telephoneRegex.test(telephone)) throw Error('Enter country code in telephone')

            if(!telephoneRegex.test(contactNumber)) throw Error('Enter country code in contact number')

            const { success, message } = await this.updateCompany({
              id: this.id,
              companyId,
              role: this.company.partnerType.id,
              email,
              telephone,
              name,
              contactPerson,
              contactNumber,
              state: this.company.stateValue,
              address
            })

            if(!success) throw Error(message)

            this.$refs.companyCreate.reset()

            this.appToast('Company updated', message, 'success')

            this.companyData()
          }
          else{

            if(!this.company.stateValue){

              this.appToast('Invalid state', 'Invalid selected state', 'danger')
            }
            else if(!this.company.partnerType){

              this.appToast('Invalid partner', 'Invalid selected partner', 'danger')
            }
          }
        }
        catch (e){

          this.appToast('Exception', e.message || 'Error while operating!', 'danger')
        }
      }
    },
  }
</script>